import { useContext, useState } from "react";

import { AppContexts } from "../../../providers";

const initialBooking = {
  reservation_id: "",
  first_name: "",
  last_name: "",
  check_in: "",
  check_out: "",
  email: "",
  phone: "",
};

const BuilderFirstBookingStep = ({ rental, onBooked }) => {
  const reservationContext = useContext(AppContexts.ReservationsContext);
  const [booking, setBooking] = useState(initialBooking);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const update = (field, value) =>
    setBooking((current) => ({ ...current, [field]: value }));

  const submit = async (event) => {
    event.preventDefault();
    const required = [
      "reservation_id",
      "first_name",
      "last_name",
      "check_in",
      "check_out",
      "phone",
    ];
    if (required.some((field) => !String(booking[field] || "").trim())) {
      setError("Complete the required booking and mobile-phone fields.");
      return;
    }
    if (booking.check_out <= booking.check_in) {
      setError("Check-out must be after check-in.");
      return;
    }

    setSaving(true);
    setError("");
    const saved = await reservationContext.insertReservation({
      ...booking,
      pms_id: rental.pms_id,
    });
    setSaving(false);

    if (!saved) {
      setError("We couldn't add this booking. Check the confirmation number.");
      return;
    }
    onBooked(saved);
  };

  return (
    <div className="guide-onboarding-simple-panel">
      <p className="guide-onboarding-intro">
        Add your first guest so you can send the finished guide. This does not
        contact the guest until the next step.
      </p>
      <form className="guide-onboarding-booking-grid" onSubmit={submit}>
        <label>
          <span>Confirmation number*</span>
          <input
            className="uk-input"
            value={booking.reservation_id}
            onChange={(event) => update("reservation_id", event.target.value)}
          />
        </label>
        <label>
          <span>Property</span>
          <input className="uk-input" value={rental?.name || ""} disabled />
        </label>
        <label>
          <span>First name*</span>
          <input
            className="uk-input"
            value={booking.first_name}
            onChange={(event) => update("first_name", event.target.value)}
          />
        </label>
        <label>
          <span>Last name*</span>
          <input
            className="uk-input"
            value={booking.last_name}
            onChange={(event) => update("last_name", event.target.value)}
          />
        </label>
        <label>
          <span>Check-in*</span>
          <input
            className="uk-input"
            type="date"
            value={booking.check_in}
            onChange={(event) => update("check_in", event.target.value)}
          />
        </label>
        <label>
          <span>Check-out*</span>
          <input
            className="uk-input"
            type="date"
            min={booking.check_in}
            value={booking.check_out}
            onChange={(event) => update("check_out", event.target.value)}
          />
        </label>
        <label>
          <span>Mobile phone*</span>
          <input
            className="uk-input"
            type="tel"
            value={booking.phone}
            onChange={(event) => update("phone", event.target.value)}
          />
        </label>
        <label>
          <span>Email</span>
          <input
            className="uk-input"
            type="email"
            value={booking.email}
            onChange={(event) => update("email", event.target.value)}
          />
        </label>
        {error && (
          <p className="guide-onboarding-error guide-onboarding-grid-full">
            {error}
          </p>
        )}
        <div className="guide-onboarding-grid-full">
          <button
            type="submit"
            className="uk-button hms-btn hms-red-btn"
            disabled={saving}
          >
            {saving ? "Adding booking…" : "Add booking and continue"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default BuilderFirstBookingStep;
